import { render, staticRenderFns } from "./my_book.vue?vue&type=template&id=51f1861a&scoped=true&"
import script from "./my_book.vue?vue&type=script&lang=js&"
export * from "./my_book.vue?vue&type=script&lang=js&"
import style0 from "./my_book.vue?vue&type=style&index=0&id=51f1861a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51f1861a",
  null
  
)

export default component.exports